// Browser-only image compression via Canvas, used where expo-image-manipulator
// can't run (web). createImageBitmap's `imageOrientation: "from-image"` applies
// EXIF rotation for us -- canvas.drawImage alone does not, and would otherwise
// bake in a sideways image for phone photos taken in portrait. Best-effort: any
// failure (unsupported format, browser quirk) falls back to the original blob
// unchanged rather than risk uploading something worse than the source.
export async function compressImageWeb(
  blob: Blob,
  maxDimension: number,
  quality: number,
): Promise<Blob> {
  try {
    // TS's bundled DOM lib here predates the 2-arg createImageBitmap
    // overload (ImageBitmapOptions); the runtime supports it regardless.
    const bitmap = await (createImageBitmap as any)(blob, {
      imageOrientation: "from-image",
    });

    const scale = Math.min(
      1,
      maxDimension / Math.max(bitmap.width, bitmap.height),
    );
    const width = Math.round(bitmap.width * scale);
    const height = Math.round(bitmap.height * scale);

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    if (!ctx) return blob;
    ctx.drawImage(bitmap, 0, 0, width, height);

    const outputType = blob.type === "image/png" ? "image/png" : "image/jpeg";
    const compressed = await new Promise<Blob | null>((resolve) =>
      canvas.toBlob(resolve, outputType, quality),
    );

    return compressed || blob;
  } catch {
    return blob;
  }
}
